const INSURERS = [
  '富邦產險',
  '國泰世紀產險',
  '新安東京海上產險',
  '明台產險',
  '和泰產險',
  '新光產險',
  '華南產險',
  '兆豐產險',
  '中國信託產險',
  '臺灣產險',
  '泰安產險',
  '第一產險',
  '南山產險',
  '旺旺友聯產險',
  '其他',
] as const;

const INSURER_OPTIONS = INSURERS.map((insurer) => ({
  value: insurer,
  label: insurer,
}));

export { INSURERS, INSURER_OPTIONS };
